import { motion } from "framer-motion";
import "./home.css";
import Parker from "../../asset/Parker.png";
export const Home = () => {
  const gradientAnimation = {
    animate: {
      backgroundPosition: ["0% 50%", "100% 50%"],
      transition: { duration: 10, repeat: Infinity, ease: "linear" },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.5, delay: 0.5 },
    },
  };

  return (
    <motion.div
      animate="animate"
      variants={gradientAnimation}
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        backgroundSize: "200% 200%",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {[...Array(4)].map((_, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0.3, scale: 0.8 }}
            animate={{
              opacity: [0.3, 0.8],
              scale: [0.8, 1],
              rotate: [0, 360],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              delay: i * 1.5,
            }}
            className="bg-transparent-card"
          />
        ))}
      </div>

      {/* Content Section */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={cardVariants}
        style={{
          textAlign: "center",
          color: "white",
          zIndex: 1,
        }}
      >
        <h1 className="welcome-text">Welcome to 🎲 CasinoRehab</h1>
        <img
          src={Parker}
          alt="parker777"
          className="parker"
          onClick={() => window.open("https://www.parker777.io/")}
        />
        <div className="exch_links">
          <button
            onClick={() => window.open("https://www.parker777.io/")}
            className="exchange"
          >
            parker exchange
          </button>
        </div>
        <p className="main-content">
          Your past does not define your future. You can always rewrite the
          story. Recovery is not for people who need it, it's for people who
          want it. Start changing what's going on within you!
        </p>
      </motion.div>
    </motion.div>
  );
};
